// COEP cross-origin isolation을 해제(`COEP: unsafe-none`)해 서빙해야 하는 경로 목록.
//
// 두 in-repo consumer가 이 단일 source of truth를 공유한다:
//   1. nuxt.config.ts `routeRules` — dev/stage(SSR Nitro)에서 실제 응답 헤더로 적용
//   2. application/plugins/11.crossOriginIsolation.client.ts — SPA 이동 시 격리 경계를
//      넘으면 full page load로 전환하는 클라이언트 guard
//
// ⚠️ 라이브는 정적 S3 호스팅이라 routeRules가 런타임에 적용되지 않는다. 라이브 헤더의
//    source of truth는 CloudFront viewer-response function이므로, 이 목록을 바꾸면
//    CloudFront function의 경로 매칭도 반드시 수동으로 동기화해야 한다.
//
// i18n strategy가 `no_prefix`라 경로에 로케일 segment가 붙지 않으므로 literal 매칭이 안전하다.
export const COEP_RELAXED_PATHS: readonly string[] = [
  "/home/pricing/checkout",
  "/settings/org",
];
